// extracted by mini-css-extract-plugin
export default {"mainContainer":"layout_mainContainer__+IAkQ"};